import { Flex, FormControl, FormLabel, Text } from '@chakra-ui/react'
import { MdClose } from 'react-icons/md'
import Modal from 'react-modal'
import { useState, useEffect } from 'react'
import { Container, Header } from './styles'
import { ButtonCmp } from '../../../../../../components/ButtonCmp'
import { iNomeId } from '../../../../../../interfaces'
import { FindUser } from '../../../../../../components/FindBox'
import { appApi } from '../../../../../../services/appApi'
import { PropInvalida } from '../../../../../../Utils/Helper'
import { ElementoTooltip } from '../../../../../../components/ElementoTooltip'

interface iModalProps {
  onRequestClose: () => void
  onConfirm: (gestorId?: string) => void
  id: string
}

export const ModalInativarColaborador: React.FC<iModalProps> = ({ onRequestClose, onConfirm, id }) => {
  const [GestorId, setGestorId] = useState<string>()
  const [ColaboradoresGestor, setColaboradoresGestor] = useState<iNomeId[]>([])

  function getColaboradores(): void {
    appApi.get(`Colaborador/TipoUsuario/${id}`)
      .then((res) => {
        if (res.data === 1 || res.data === 2) {
          appApi.get('Colaborador/Gestores')
            .then(e => setColaboradoresGestor(e.data))
            .catch(err => console.log(err))
        }
      })
      .catch(err => console.log(err))
  }

  useEffect(() => {
    getColaboradores()
  }, [])

  return (
    <Modal
      isOpen
      onRequestClose={onRequestClose}
      overlayClassName='react-modal-overlay'
      className={'react-modal-content-scroll'}
    >
      <Container width={'50rem'}>
        <Header>
          <Flex width={'100%'} justifyContent={'center'}>
            <h3>Atenção!</h3>
          </Flex>
          <Flex>
            <MdClose size={24} onClick={onRequestClose} />
          </Flex>
        </Header>
        <Flex justifyContent={'center'} p={'1rem'} flexDir='column' gap={'1rem'}>
          <Text
            fontFamily={'Roboto'}
            fontWeight={'700'}
            textAlign='center'
            fontSize={'0.875rem'}
          >
            {ColaboradoresGestor?.length > 0 ? 'Antes de prosseguir com o processo de inativar o colaborador, defina os responsáveis substitutos!' : 'Tem certeza que deseja inativar esse colaborador? Todos os processos em andamento serão interrompidos?'}
          </Text>

          {ColaboradoresGestor?.length > 0 && <FormControl>
            <FormLabel fontSize={'0.875rem'}>Gestor substituto</FormLabel>
            <FindUser
              selecionado={GestorId ?? ''}
              lista={ColaboradoresGestor.filter(e => e.id !== id)}
              onChoice={setGestorId}
            />
          </FormControl>}

          <Flex gap={'1rem'} justifyContent='center'>
            <ButtonCmp
              VarColor='c6'
              onClick={() => onRequestClose()}
            >Cancelar</ButtonCmp>

            <ElementoTooltip label={(ColaboradoresGestor.length > 0 && PropInvalida(GestorId)) ? 'Preencha todos os campos!' : ''}>
              <ButtonCmp
                VarColor='Green2'
                onClick={() => onConfirm(GestorId)}
                isDisabled={ColaboradoresGestor.length > 0 && PropInvalida(GestorId)}
              >Continuar</ButtonCmp>
            </ElementoTooltip>
          </Flex>
        </Flex>
      </Container>
    </Modal>
  )
}
